/**
 * budgetFormat — shared currency formatters, colour maps and the cap-state
 * helper for the budget panel and its extracted cards. Single source of truth
 * so MyBudgetPanel, the cards and the useBudgetData hook all format alike.
 */
export const USD0 = (n) => `$${Math.round(Number(n || 0)).toLocaleString()}`;
export const USD2 = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Per-tool donut colours — shared visual language with the Team / Org panels.
// Cursor is teal and OpenAI API magenta: mid-tones that read on light and
// dark cards and stay clear of the Claude oranges and the Copilot black/blue.
export const CURSOR_COLOR = '#08979c';
export const CODEX_COLOR = '#c41d7f';
export const TOOL_DONUT_COLORS = {
  claude_code: '#cc785c', claude_ai: '#d97757', github_copilot: '#1f1f1f', microsoft_copilot: '#0078d4',
  cursor: CURSOR_COLOR, codex: CODEX_COLOR,
};
export const TOOL_COMPONENT_COLORS = {
  claude_code: '#cc785c', claude_ai: '#d97757', claude: '#cc785c',
  claude_license: '#b85c44', github_copilot: '#1f1f1f', microsoft_copilot: '#0078d4',
  cursor: CURSOR_COLOR, codex: CODEX_COLOR,
};

// Display name per billing tool key, for surfaces that get only the key.
export const TOOL_NAMES = {
  claude: 'Claude',
  github_copilot: 'GitHub Copilot',
  microsoft_copilot: 'Microsoft 365 Copilot',
  cursor: 'Cursor',
  codex: 'OpenAI API',
};

// Qualitative palette for the budget-source pie (one slice per team budget).
export const SOURCE_COLORS = ['#1677ff', '#52c41a', '#faad14', '#722ed1', '#13c2c2', '#eb2f96', '#fa8c16', '#2f54eb'];

// Spend / cap ratios at which a cap turns 'warn' (high) or 'under' (low).
const CAP_WARN_RATIO = 0.85;
const CAP_UNDER_RATIO = 0.55;

export function capState(spend, cap) {
  if (cap > 0) {
    const r = spend / cap;
    if (r > 1) {return 'over';}
    if (r >= CAP_WARN_RATIO) {return 'warn';}
    if (r < CAP_UNDER_RATIO) {return 'under';}
    return 'ok';
  }
  return 'none';
}
